import React, {useState} from 'react';


import {useLocation, useParams} from "react-router-dom";
import toFaNumber from "@/lib/utils/number";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";

import {useApiDeleteAdminClassroom, useApiReadAdminClassroom, useApiUpdateAdminClassroom} from "@/api/classroom";
import ClassroomForm from "@/pages/admin/classroom/edit/[id]/_section/ClassroomForm";
import ApiHandleSuccessMessage from "@/lib/helper/apiHandleResultMessage";


function AdminClassroomEditPage() {

    const {id} = useParams();
    const {hash} = useLocation();

    const [myTab, setMyTab] = useState('edit')

    const {data: classroomData, isPending, isSuccess, refetch} = useApiReadAdminClassroom(id)

    const {mutate: updateClassroom, isPendingUpdate} = useApiUpdateAdminClassroom()

    const {mutate: deleteClassroom, isPendingDelete} = useApiDeleteAdminClassroom()

    return (
        <AdminLayout pageTitle={'ویرایش محل برگزاری کلاس' + ' #' + toFaNumber(id)}
                     backTo={URLS.admin.classroom.dashboard}>
            <ClassroomForm
                classroomData={classroomData?.data?.data}
                loading={isPending}
                onSubmit={(values) => {
                    updateClassroom(
                        {
                            id,
                            ...values
                        },
                        {
                            onSuccess(r) {
                                ApiHandleSuccessMessage(r)
                                refetch();
                            }
                        }
                    );
                }}
            />

        </AdminLayout>
    );

}

export default AdminClassroomEditPage;
